import { pushEphemeralTruth, type EphemeralTruth } from '../shared/ephemeral-truth';
import { pingFrame, rulerFrame, spotlightFrame, type PresentationContext } from '../janus-engine/presentation/ft3d';
import { createPreviewPostQueue } from './ft3d-ability-targeting-preview-post';
import type { Ft3dRulerFrame } from '../shared/ft3d-ruler-frame';
type Row = Record<string, any>;
let lastPingAt = -Infinity;
function context(input: Row): PresentationContext {
    const ft = window.FateTide as Row | undefined;
    const encounterId = String(input.encounter_id ?? '');
    const campaignId = String(input.campaign_id ?? '');
    return { encounterId, campaignId, actorId: String(input.caster_id ?? ''),
        userId: String(ft?.user?.id ?? ''), displayName: String(ft?.user?.username ?? ''), canManage: input.canManage === true,
        encounter: ft?.encounterCache?.get(encounterId) ?? ft?.encounterArr ?? null,
        campaign: ft?.campaignCache?.get(campaignId) ?? ft?.campaignArr ?? null };
}
function send(frame: Row): boolean { return pushEphemeralTruth(frame as EphemeralTruth); }
let rulerTransportNoted = false;
const rulerOperations = new Set<string>();
function noteRulerTransport(reason: string): void {
    if (rulerTransportNoted) return;
    rulerTransportNoted = true;
    ftDebugLog('ws', { rulerTransportUnavailable: reason, localRulerAvailable: true });
}
function sendRuler(frame: Ft3dRulerFrame): void {
    rulerOperations.add(frame.operation_id);
    if (rulerOperations.size > 512) rulerOperations.delete(rulerOperations.values().next().value!);
    if (!send(frame)) { rulerOperations.delete(frame.operation_id); noteRulerTransport('transport-unavailable'); }
}
const rulerPost = createPreviewPostQueue(async body => {
    const frame = JSON.parse(body) as Ft3dRulerFrame;
    // Clear posts retire pending updates in the shared queue. Their actual send is unconditional
    // below, so a second clear cannot wait behind an in-flight clear and be replaced by an update.
    if (frame.type !== 'ft3d_ruler_clear') sendRuler(frame);
}, () => false, undefined, 100);
window.addEventListener('ft:ephemeral-truth-refused', event => {
    const control = (event as CustomEvent<{ operation_id?: string; reason?: string }>).detail;
    if (control?.operation_id && rulerOperations.delete(control.operation_id)) noteRulerTransport(control.reason ?? 'refused');
});
declare global {
    interface Window { ftPushFt3dRuler?: (body: Row, input: Row) => Ft3dRulerFrame | null }
}
Object.assign(window, {
    ftPushFt3dPing(request: Row, input: Row): Row {
        const now = Date.now(), frame = pingFrame(context(input), request, now, lastPingAt);
        if (!send(frame)) throw new Error('ping:transport-unavailable');
        lastPingAt = now;
        return frame;
    },
    ftPushFt3dRuler(body: Row, input: Row): Ft3dRulerFrame | null {
        try {
            const frame = rulerFrame(context(input), body);
            rulerPost.post(frame.type === 'ft3d_ruler_clear' ? 'clear' : 'update', JSON.stringify(frame));
            if (frame.type === 'ft3d_ruler_clear') sendRuler(frame);
            return frame;
        } catch (error) { noteRulerTransport(String(error)); return null; }
    },
    ftPushFt3dSpotlight(body: Row, input: Row): boolean { return send(spotlightFrame(context(input), body)); },
});
